<div class="profile-container">
  <div class="">
    <div class="profile-content">

      <div class="personal-details">

        <div class="header-block">
          <div class="header-title">
            <app-breadcrumb></app-breadcrumb>
          </div>
          <div class="add-block">
            <div class="search">
              <form autocomplete="off">
                <input type="text" placeholder="{{ 'generic.search' | translate }}" (keyup.enter)="getTelcoCustomerByWildSearch()" [ngModelOptions]="{standalone: true}" [(ngModel)]="searchFilter">
              </form>
              <i class="bi bi-search" (click)="getTelcoCustomerByWildSearch()"></i>
            </div>
            <button *ngIf="actionControls.isAdd" (click)="mapLoad()" data-toggle="modal" data-target="#addModal"><i
                class="bi bi-plus-lg"></i> {{ 'generic.add' | translate }}</button>
          </div>
        </div>

        <table class="table table-striped">
          <thead>
            <tr>
              <th style="width: 10%;">{{ 'telco-customer-info.id' | translate }}</th>
              <th style="width: 20%;">{{ 'telco-customer-info.customerName' | translate }}</th>
              <th style="width: 20%;">{{ 'telco-customer-info.mobile' | translate }}</th>
              <th style="width: 20%;">{{ 'telco-customer-info.emailId' | translate }}</th>
              <th style="width: 15%;">{{ 'telco-customer-info.createdDate' | translate }}</th>
              <th style="width: 15%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate }}</th>
            </tr>
          </thead>
        </table>
        <div *ngIf="!isLoading">
          <div class="data-view" *ngFor="let list of telcoCustomerList | paginate : {
                    itemsPerPage: tableSize,
                    currentPage: page,
                    totalItems: count
                  }  ;let i = index">

            <p style="width: 10%;" title="{{list.telcoCustomerId}}">{{list.telcoCustomerId}}</p>
            <p style="width: 20%;" title="{{list.customerName}}">{{list.customerName}}</p>
            <p style="width: 20%;" title="{{list.customerPhoneNumber}}">{{list.customerPhoneNumber}}</p>
            <p style="width: 20%;" title="{{list.customerEmailId}}">{{list.customerEmailId}}</p>
            <p style="width: 15%;" title="{{list.createdDate}}">{{list.createdDate | date}}</p>

            <p class="action-buttons" style="width: 15%;padding-left: 25px;">
              <i *ngIf="actionControls.isView" class="bi bi-eye-fill"
                (click)="getTelcoCustomerById(list.telcoCustomerId)" data-toggle="modal" data-target="#viewModal"></i>
              <i *ngIf="actionControls.isModify" title="{{ 'generic.edit' | translate }}" class="bi bi-pencil-square"
                (click)="openEditModal(list)" data-toggle="modal" data-target="#updateModal"></i>
              <i *ngIf="actionControls.isDelete" title="{{ 'generic.delete' | translate }}" class="bi bi-trash3"
                (click)="deleteIdSelect(list.id,list)" data-toggle="modal" data-target="#deleteModal"></i>

            </p>
          </div>
        </div>


        <div class="loader" *ngIf="isLoading">
          <div class="spinner"></div>
        </div>

        <div class="loader" *ngIf="!isLoading && telcoCustomerList.length == 0">
          <div class="no-data">
            <img src="assets/no-data-6.png" alt="">
            <p>{{ 'telco-customer-info.noDataFound' | translate }}</p>
          </div>

        </div>

        <div class="paginator">
          <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
            [totalRecords]="count" [showFirstLastIcon]="false" [showCurrentPageReport]="true"
            currentPageReportTemplate="{first} - {last} of {totalRecords}">
          </p-paginator>
        </div>


      </div>
    </div>
  </div>
</div>



<div class="modal fade" id="addModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'telco-customer-info.headings.addLive' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div>
          <form [formGroup]="addForm" class="form-container">
            <!-- <h2>Telco Customer Form</h2> -->

            <!-- Basic Info -->
            <div class="section">
              <div class="row">



                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>Customer Id: <span class="required">*</span></label>
                    <input formControlName="customerId" class="form-control" placeholder="Customer Id" />
                  </div>
                </div>

                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>Customer Name: <span class="required">*</span></label>
                    <input class="form-control" formControlName="customerName" placeholder="Name" />
                  </div>
                </div>

                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>Email: <span class="required">*</span></label>
                    <input class="form-control" formControlName="customerEmailId" placeholder="Email ID" />
                  </div>
                </div>

                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>Phone Number: <span class="required">*</span></label>
                    <input class="form-control" formControlName="customerPhoneNumber" type="number"
                      placeholder="Phone Number" />
                  </div>
                </div>

                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>Location: <span class="required">*</span></label>
                    <select name="" id="" formControlName="customerLocation" class="form-control">
                      <option value="" selected disabled> -- select location --</option>
                      <option value="{{list.zone}}" *ngFor="let list of locationList">{{list.zone}} - {{list.city}} -
                        {{list.postalCode}}</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>Branch:</label>
                    <select name="" id="" formControlName="customerBranch" class="form-control">
                      <option value="" selected disabled> -- select branch --</option>
                      <option value="{{list.name}}" *ngFor="let list of branchList">{{list.name}}</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>Department:</label>
                    <select name="" id="" formControlName="customerDepartment" class="form-control">
                      <option value="" selected disabled> -- select department--</option>
                      <option value="{{list.departmentName}}" *ngFor="let list of departmentInfoList">
                        {{list.departmentName}}</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-12 col-lg-12">
                  <div class="form-group">
                    <label>Address: <span class="required">*</span></label>
                    <textarea name="" class="form-control" placeholder="Address" formControlName="primaryAddress"
                      id=""></textarea>
                  </div>
                </div>

                <div class="col-md-12 col-lg-12">
                  <div class="map-frame">
                    <div id="map">
                    </div>
                  </div>
                  <div class="remove-mark">
                    <button (click)="removeMark()">{{'generic.remove' | translate}}</button>

                  </div>
                </div>


                <div class="col-md-12 col-lg-12">
                  <div class="proof-block">
                    <div class="proof-block-list block-list">
                      <div>
                        <label>Building Proof:</label>
                        <p class="note">(Note: Allowed extensions are jpg, jpeg, png and file size should be less than
                          10MB)</p>
                      </div>
                      <div hidden="true">
                        <input #buildingProof type="file" id="buildingProof" accept="image/*" hidden="true"
                          (change)="onImageChange($event,'buildingProof','add')">
                      </div>
                      <button class="add-proof-btn" *ngIf="addForm.get('buildingProof').value == ''"
                        (click)="addImageButton('buildingProof')">{{ 'generic.add' | translate }}</button>
                      <div class="proof-image" *ngIf="addForm.get('buildingProof').value != ''">
                        <img [src]="addForm.get('buildingProof').value" alt="">
                        <button (click)="removeIcon('buildingProof','add')">{{ 'generic.remove' | translate }}</button>
                      </div>
                    </div>
                    <div class="proof-block-list block-list">
                      <div>
                        <label>Identity Proof:</label>
                        <p class="note">(Note: Allowed extensions are jpg, jpeg, png and file size should be less than
                          10MB)</p>
                      </div>
                      <div hidden="true">
                        <input #identityProof type="file" id="identityProof" accept="image/*" hidden="true"
                          (change)="onImageChange($event,'identityProof','add')">
                      </div>
                      <button class="add-proof-btn" *ngIf="addForm.get('identityProof').value == ''"
                        (click)="addImageButton('identityProof')">{{ 'generic.add' | translate }}</button>
                      <div class="proof-image" *ngIf="addForm.get('identityProof').value != ''">
                        <img [src]="addForm.get('identityProof').value" alt="">
                        <button (click)="removeIcon('identityProof','add')">{{ 'generic.remove' | translate }}</button>
                      </div>
                    </div>
                    <div class="proof-block-list block-list">
                      <div>
                        <label>Photo Proof:</label>
                        <p class="note">(Note: Allowed extensions are jpg, jpeg, png and file size should be less than
                          10MB)</p>
                      </div>
                      <div hidden="true">
                        <input #photoProof type="file" id="photoProof" accept="image/*" hidden="true"
                          (change)="onImageChange($event,'photoProof','add')">
                      </div>
                      <button class="add-proof-btn" *ngIf="addForm.get('photoProof').value == ''"
                        (click)="addImageButton('photoProof')">{{ 'generic.add' | translate }}</button>
                      <div class="proof-image" *ngIf="addForm.get('photoProof').value != ''">
                        <img [src]="addForm.get('photoProof').value" alt="">
                        <button (click)="removeIcon('photoProof','add')">{{ 'generic.remove' | translate }}</button>
                      </div>
                    </div>
                    <div class="proof-block-list block-list">
                      <div>
                        <label>Address Proof:</label>
                        <p class="note">(Note: Allowed extensions are jpg, jpeg, png and file size should be less than
                          10MB)</p>
                      </div>
                      <div hidden="true">
                        <input #addressProof type="file" id="addressProof" accept="image/*" hidden="true"
                          (change)="onImageChange($event,'addressProof','add')">
                      </div>
                      <button class="add-proof-btn" *ngIf="addForm.get('addressProof').value == ''"
                        (click)="addImageButton('addressProof')">{{ 'generic.add' | translate }}</button>
                      <div class="proof-image" *ngIf="addForm.get('addressProof').value != ''">
                        <img [src]="addForm.get('addressProof').value" alt="">
                        <!-- <div class="loader-image">
                                       <i class="bi bi-arrow-clockwise"></i>
                                   </div> -->
                        <button (click)="removeIcon('addressProof','add')">{{ 'generic.remove' | translate }}</button>
                      </div>
                    </div>
                  </div>
                </div>

                <!--  <div class="col-md-6 col-lg-6">
                      <div class="form-group">
                        
                      </div>
                  </div> -->
              </div>
            </div>

            <hr />

            <!-- Service Info -->




            <h3 class="title-header">{{ 'telco-customer-info.serviceInfo' | translate }} <i class="bi bi-plus-circle"
                (click)="addServiceInfo()"></i></h3>
            <div formArrayName="serviceInfo" class="section">

              <div *ngFor="let service of serviceInfo?.controls; let i = index" [formGroupName]="i"
                class="nested-group">

                <div class="row">


                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Service:</label>
                      <select name="" id="" class="form-control" formControlName="serviceName">
                        <option [value]="service.name" *ngFor="let service of serviceData">{{service.name}}</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Service Id:</label>
                      <input formControlName="serviceId" class="form-control" placeholder="Service Id" />
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Service Status:</label>
                      <select name="" formControlName="serviceStatus" class="form-control">
                        <option value="">-- select status --</option>
                        <option value="Active">{{'generic.active' | translate}}</option>
                        <option value="InActive">{{'generic.inactive' | translate}}</option>

                      </select>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Service Info:</label>
                      <input formControlName="serviceInfo" class="form-control" placeholder="Service Info" />
                    </div>
                  </div>


                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Ext Customer Id:</label>
                      <input formControlName="extCustomerId" class="form-control" placeholder="Ext Customer Id" />
                    </div>
                  </div>



                  <!-- <div class="col-md-6 col-lg-6">
                      <div class="form-group">
                          <label>Asset:</label>
                          <select name="" (change)="onAssetSelect(i)" formControlName="assetId" class="form-control">
                              <option value="" selected disabled> -- select asset--</option>
                              <option value="{{list.objectInfoId}}" *ngFor="let list of objectInfoList">{{list.givenName}}</option>
                          </select>
                      </div>
                  </div> -->

                </div>


                <!-- SIP Info -->
                <div formArrayName="sipInfo" class="sub-section">
                  <h5>{{ 'telco-customer-info.sipInfo' | translate }} <i class="bi bi-plus-circle"
                      (click)="addSipInfo(i)"></i></h5>
                  <div *ngFor="let sip of getSipInfoControls(i); let j = index" [formGroupName]="j">


                    <div class="row">
                      <div class="col-md-5 col-lg-5">
                        <div class="form-group">
                          <input formControlName="sipName" class="form-control" placeholder="SIP Name" />
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                          <input formControlName="sipValue" class="form-control" placeholder="SIP Value" />
                        </div>
                      </div>
                      <div class="col-md-1 col-lg-1 remove">
                        <i class="bi bi-trash" (click)="removeSipInfo(i,j)"></i>
                      </div>
                    </div>


                    <!-- <div formArrayName="keyValueDto" class="keyvalue-section">
                      <div
                        *ngFor="let kv of (sip.get('keyValueDto')?.['controls'] || []); let k = index"
                        [formGroupName]="k"
                      >
                        <input formControlName="key" placeholder="Key" />
                        <input formControlName="value" placeholder="Value" />
                      </div>
                    </div> -->
                  </div>
                </div>


                <!-- <div class="sub-section">
                  <h5>{{'telco-customer-info.asset' | translate}} </h5>

                    <div class="row">
                      <div class="col-md-12 col-lg-12">
                        <div class="form-group">
                            <select name="" (change)="onAssetSelect(i)" formControlName="assetId" class="form-control">
                              <option value="" selected disabled> -- select asset--</option>
                              <option value="{{list.objectInfoId}}" *ngFor="let list of objectInfoList">{{list.givenName}}</option>
                            </select>
                        </div>
                      </div>
                    </div>
                </div> -->
                <div>

                  <div class="sub-section">
                    <h5>{{'telco-customer-info.asset' | translate}}</h5>

                    <div class="row">

                      <!-- Multi-select -->
                      <div class="col-md-12 col-lg-12">
                        <ng-multiselect-dropdown [placeholder]="'Select Asset'" [ngModel]="getSelectedAssets(i)"
                          [settings]="objectDropdownSettings" [data]="objectInfoList"
                          [ngModelOptions]="{standalone: true}" (onSelect)="onObjectSelect($event,i)"
                          (onDeSelect)="onObjectDeSelect($event, i)">

                          >
                        </ng-multiselect-dropdown>
                      </div>

                    </div>

                  </div>
                </div>


                <!-- DIP Info -->
                <div formArrayName="dipInfo" class="sub-section">
                  <h5>{{ 'telco-customer-info.dipInfo' | translate }} <i class="bi bi-plus-circle"
                      (click)="addDipInfo(i)"></i></h5>
                  <div *ngFor="let dip of getDipInfoControls(i); let j = index" [formGroupName]="j">
                    <div class="row">
                      <div class="col-md-5 col-lg-5">
                        <div class="form-group">
                          <input formControlName="dipName" class="form-control" placeholder="DIP Name" />
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                          <input formControlName="dipValue" class="form-control" placeholder="DIP Value" />
                        </div>
                      </div>
                      <div class="col-md-1 col-lg-1 remove">
                        <i class="bi bi-trash" (click)="removeDipInfo(i,j)"></i>
                      </div>
                    </div>

                    <!-- <div formArrayName="keyValueDto" class="keyvalue-section">
                      <div
                        *ngFor="let kv of (dip.get('keyValueDto')?.['controls'] || []); let k = index"
                        [formGroupName]="k"
                      >
                        <input formControlName="key" placeholder="Key" />
                        <input formControlName="value" placeholder="Value" />
                      </div>
                    </div> -->
                  </div>
                </div>

                <!-- Dealer Info -->
                <div formArrayName="dealerInfo" class="sub-section">
                  <h5>{{ 'telco-customer-info.dealerInfo' | translate }} <i class="bi bi-plus-circle"
                      (click)="addDealerInfo(i)"></i></h5>
                  <div *ngFor="let dealer of getDealerInfoControls(i); let j = index" [formGroupName]="j">


                    <div class="row">
                      <div class="col-md-5 col-lg-5">
                        <div class="form-group">
                          <select name="" formControlName="dealerId" class="form-control">
                            <option value="" selected disabled> -- {{ 'generic.select' | translate }} {{
                              'telco-customer-info.dealerInfo' | translate }} --</option>
                            <option value="{{list.idealerId}}" *ngFor="let list of dealerList">{{list.name}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                          <select name="" id="" formControlName="dealerLocation" class="form-control">
                            <option value="" selected disabled> -- select location --</option>
                            <option value="{{list.zone}}" *ngFor="let list of locationList">{{list.zone}} -
                              {{list.city}} - {{list.postalCode}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-1 col-lg-1 remove">
                        <i class="bi bi-trash" (click)="removeDealerInfo(i,j)"></i>
                      </div>
                    </div>

                    <!-- <div formArrayName="keyValueDto" class="keyvalue-section">
                      <div
                        *ngFor="let kv of (dealer.get('keyValueDto')?.['controls'] || []); let k = index"
                        [formGroupName]="k"
                      >
                        <input formControlName="key" placeholder="Key" />
                        <input formControlName="value" placeholder="Value" />
                      </div>
                    </div> -->
                  </div>
                </div>

                <div class="service-remove">
                  <button type="button" (click)="serviceInfo.removeAt(i)"> <i class="bi bi-trash"></i> {{
                    'telco-customer-info.removeService' | translate }}</button>
                </div>

              </div>

              <!-- <button type="button" (click)="addServiceInfo()">+ Add New Service</button> -->
            </div>

            <hr />

            <!-- Key Values -->
            <!-- <div formGroupName="keyValues" class="section">
              <h3>{{'telco-customer-info.keyValuesTitle' | translate}}</h3>


              <input formControlName="key" placeholder="Key" />
              <input formControlName="value" placeholder="Value" />
            </div> -->

            <!-- Actions -->
            <!-- <div class="actions">
              <button type="submit" [disabled]="addForm.invalid">💾 Submit</button>
              <button type="button" (click)="clearForm()">🧹 Clear</button>
            </div> -->
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeAddModal" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' |
            translate }}</button>
          <button type="button" (click)="addTelcoCustomer()" class="btn btn-primary">{{ 'generic.add' | translate
            }}</button>
        </div>
      </div>
    </div>
  </div>
</div>







<div class="modal fade" id="viewModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'telco-customer-info.headings.liveDetails' | translate }}
          <span data-dismiss="modal" (click)="closeView()">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div>
          <div *ngFor="let list of telcoCustomerData" class="form-container">
            <!-- <h2>Telco Customer Form</h2> -->

            <!-- Basic Info -->
            <div class="section">
              <div class="row">
                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>{{ 'telco-customer-info.customerId' | translate }}:</label>
                    <p>{{list.customerId || " -- "}}</p>
                  </div>
                </div>

                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>{{ 'telco-customer-info.customerName' | translate }}:</label>
                    <p>{{list.customerName || " -- "}}</p>
                  </div>
                </div>

                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>{{ 'telco-customer-info.customerEmailId' | translate }}:</label>
                    <p>{{list.customerEmailId || " -- "}}</p>
                  </div>
                </div>

                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>{{ 'telco-customer-info.customerPhoneNumber' | translate }}:</label>
                    <p>{{list.customerPhoneNumber || " -- "}}</p>
                  </div>
                </div>

                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>{{ 'telco-customer-info.customerLocation' | translate }}:</label>
                    <p>{{list.customerLocation || " -- "}}</p>
                  </div>
                </div>

                <div class="col-md-6 col-lg-6" *ngIf="list.customerBranch">
                  <div class="form-group">
                    <label>{{ 'telco-customer-info.customerBranch' | translate }}:</label>
                    <p>{{list.customerBranch || " -- "}}</p>
                  </div>
                </div>

                <div class="col-md-6 col-lg-6" *ngIf="list.customerDepartment">
                  <div class="form-group">
                    <label>{{ 'telco-customer-info.customerDepartment' | translate }}:</label>
                    <p>{{list.customerDepartment || " -- "}}</p>
                  </div>
                </div>

                <div class="col-md-12 col-lg-12">
                  <div class="form-group">
                    <label>{{ 'telco-customer-info.primaryAddress' | translate }}:</label>
                    <p>{{list.primaryAddress || " -- "}}</p>
                  </div>
                </div>





                <div class="identity-proof-details col-md-3 col-lg-3">
                  <p class="identity-proof-title">{{ 'telco-customer-info.buildingProof' | translate }}:</p>
                  <div class="row identity-proof-form-details">
                    <div class=" identity-proof-form">
                      <div class="proof-images" *ngIf="list.buildingProof != ''">
                        <div class="image">
                          <p-image src="{{list.buildingProof}}" alt="Image" [preview]="true"></p-image>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="identity-proof-details col-md-3 col-lg-3">
                  <p class="identity-proof-title">{{ 'telco-customer-info.identityProof' | translate }}:</p>
                  <div class="row identity-proof-form-details">
                    <div class=" identity-proof-form">
                      <div class="proof-images" *ngIf="list.identityProof != ''">
                        <div class="image">
                          <p-image src="{{list.identityProof}}" alt="Image" [preview]="true"></p-image>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="identity-proof-details col-md-3 col-lg-3">
                  <p class="identity-proof-title">{{ 'telco-customer-info.photoProof' | translate }}:</p>
                  <div class="row identity-proof-form-details">
                    <div class=" identity-proof-form">
                      <div class="proof-images" *ngIf="list.photoProof != ''">
                        <div class="image">
                          <p-image src="{{list.photoProof}}" alt="Image" [preview]="true"></p-image>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="identity-proof-details col-md-3 col-lg-3">
                  <p class="identity-proof-title">{{ 'telco-customer-info.addressProof' | translate }}:</p>
                  <div class="row identity-proof-form-details">
                    <div class=" identity-proof-form">
                      <div class="proof-images" *ngIf="list.addressProof != ''">
                        <div class="image">
                          <p-image src="{{list.addressProof}}" alt="Image" [preview]="true"></p-image>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>

            <hr />

            <!-- Service Info -->
            <h3 class="title-header">{{ 'telco-customer-info.serviceInfo' | translate }} </h3>
            <div class="section">

              <div *ngFor="let service of list.serviceInfo; let i = index" class="nested-group">

                <div class="row">
                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>{{ 'telco-customer-info.serviceId' | translate }}:</label>
                      <p>{{service.serviceId || " -- "}}</p>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>{{ 'telco-customer-info.serviceStatus' | translate }}:</label>
                      <p>{{service.serviceStatus || " -- "}}</p>
                    </div>
                  </div>


                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>{{ 'telco-customer-info.serviceName' | translate }}:</label>
                      <p>{{service.serviceName || " -- "}}</p>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>{{ 'telco-customer-info.serviceInfo' | translate }}:</label>
                      <p>{{service.serviceInfo || " -- "}}</p>

                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>{{ 'telco-customer-info.extCustomerId' | translate }}:</label>
                      <p>{{service.extCustomerId || " -- "}}</p>
                    </div>
                  </div>

                  <!-- <div class="col-md-12 col-lg-12">
                    <div class="form-group">
                      <label>Asset:</label>
                      <div class="asset-details-list">
                        <p *ngFor="let list of service.assetDetails">{{list.assetName}}, </p>
                      </div>
                    </div>
                  </div> -->
                  <div class="col-md-12 col-lg-12">
                    <div class="status-table">
                      <table class="table">
                        <thead>
                          <tr>
                            <th style="width: 30%;">{{ 'telco-customer-info.assetId' | translate }}</th>
                            <th style="width: 70%;text-align: center;">{{ 'telco-customer-info.asset' | translate }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let list of service.assetDetails">
                            <td style="width: 30%;">{{list.assetId}}</td>
                            <td style="width: 70%;text-align: center;">{{list.assetName}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>


                </div>


                <!-- SIP Info -->
                <div class="sub-section" *ngIf="service.sipInfo && service.sipInfo != null && service.sipInfo != ''">
                  <h5>{{ 'telco-customer-info.sipInfo' | translate }}</h5>
                  <div *ngFor="let sip of service.sipInfo; let j = index;let last = last">


                    <div class="row">
                      <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                          <label>{{ 'telco-customer-info.sipName' | translate }}:</label>

                          <p>{{sip.sipName || " -- "}}</p>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                          <label>{{ 'telco-customer-info.sipValue' | translate }}:</label>
                          <p>{{sip.sipValue || " -- "}}</p>
                        </div>
                      </div>

                    </div>
                    <hr *ngIf="!last">
                  </div>
                </div>

                <!-- DIP Info -->
                <div class="sub-section" *ngIf="service.dipInfo && service.dipInfo != null && service.dipInfo != ''">
                  <h5>{{ 'telco-customer-info.dipInfo' | translate }} </h5>
                  <div *ngFor="let dip of service.dipInfo; let j = index;let last = last">
                    <div class="row">
                      <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                          <label>{{ 'telco-customer-info.dipName' | translate }}:</label>
                          <p>{{dip.dipName || " -- "}}</p>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                          <label>{{ 'telco-customer-info.dipValue' | translate }}:</label>
                          <p>{{dip.dipValue || " -- "}}</p>
                        </div>
                      </div>
                    </div>
                    <hr *ngIf="!last">
                  </div>
                </div>

                <!-- Dealer Info -->
                <div class="sub-section"
                  *ngIf="service.dealerInfo && service.dealerInfo != null && service.dealerInfo != ''">
                  <h5>{{ 'telco-customer-info.dealerInfo' | translate }} </h5>
                  <div *ngFor="let dealer of service.dealerInfo; let j = index;let last = last">
                    <div class="row">
                      <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                          <label>{{ 'telco-customer-info.dealerName' | translate }}:</label>

                          <p>{{dealer.dealerName || " -- "}}</p>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                          <label>{{ 'telco-customer-info.dealerLocation' | translate }}:</label>

                          <p>{{dealer.dealerLocation || " -- "}}</p>
                        </div>
                      </div>
                    </div>
                    <hr *ngIf="!last">
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12 col-lg-12">
              <div class="map-frame-full-width">
                <div id="mapView">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeViewModal" (click)="closeView()" class="btn btn-secondary"
            data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>




<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg" (click)="clearData()"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}}”</span>?</p>
        <div class="modal-footer">
          <button type="button" id="closeDeleteModal" (click)="clearData()" class="btn btn-secondary"
            data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
          <button type="button" (click)="telcoCustomerSoftDelete()" class="btn btn-primary">{{ 'generic.delete' |
            translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>



<div class="modal fade" id="updateModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'telco-customer-info.headings.edit' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div>
          <form [formGroup]="editForm" class="form-container">
            <!-- <h2>Telco Customer Form</h2> -->

            <!-- Basic Info -->
            <div class="section">
              <div class="row">

                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>Customer Id: <span class="required">*</span></label>
                    <input formControlName="customerId" class="form-control" placeholder="Customer Id" />
                  </div>
                </div>

                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>Customer Name: <span class="required">*</span></label>
                    <input class="form-control" formControlName="customerName" placeholder="Name" />
                  </div>
                </div>

                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>Email: <span class="required">*</span></label>
                    <input class="form-control" formControlName="customerEmailId" placeholder="Email ID" />
                  </div>
                </div>

                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>Phone Number: <span class="required">*</span></label>
                    <input class="form-control" formControlName="customerPhoneNumber" type="number"
                      placeholder="Phone Number" />
                  </div>
                </div>

                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>Location: <span class="required">*</span></label>
                    <select name="" id="" formControlName="customerLocation" class="form-control">
                      <option value="" selected disabled> -- select location --</option>
                      <option value="{{list.zone}}" *ngFor="let list of locationList">{{list.zone}} - {{list.city}} -
                        {{list.postalCode}}</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>Branch:</label>
                    <select name="" id="" formControlName="customerBranch" class="form-control">
                      <option value="" selected disabled> -- select branch --</option>
                      <option value="{{list.name}}" *ngFor="let list of branchList">{{list.name}}</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>Department:</label>
                    <select name="" id="" formControlName="customerDepartment" class="form-control">
                      <option value="" selected disabled> -- select department--</option>
                      <option value="{{list.departmentName}}" *ngFor="let list of departmentInfoList">
                        {{list.departmentName}}</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-12 col-lg-12">
                  <div class="form-group">
                    <label>Address: <span class="required">*</span></label>
                    <textarea name="" class="form-control" placeholder="Address" formControlName="primaryAddress"
                      id=""></textarea>
                  </div>
                </div>

                <div class="col-md-12 col-lg-12">
                  <div class="map-frame">
                    <div id="mapEdit">
                    </div>
                  </div>
                  <div class="remove-mark">
                    <button (click)="removeMark()">{{'generic.remove' | translate}}</button>

                  </div>
                </div>




                <div class="col-md-12 col-lg-12">
                  <div class="proof-block">
                    <div class="proof-block-list block-list">
                      <div>
                        <label>{{ 'telco-customer-info.buildingProof' | translate }}:</label>
                        <p class="note">{{ 'telco-customer-info.proofNote' | translate }}</p>
                      </div>
                      <div hidden="true">
                        <input #buildingProofEdit type="file" id="buildingProofEdit" accept="image/*" hidden="true"
                          (change)="onImageChange($event,'buildingProof','edit')">
                      </div>
                      <button class="add-proof-btn" *ngIf="editForm.get('buildingProof').value == ''"
                        (click)="addImageButton('buildingProofEdit')">{{ 'generic.add' | translate }}</button>
                      <div class="proof-image" *ngIf="editForm.get('buildingProof').value != ''">
                        <img [src]="editForm.get('buildingProof').value" alt="">
                        <button (click)="removeIcon('buildingProof','edit')">{{ 'generic.remove' | translate }}</button>
                      </div>
                    </div>
                    <div class="proof-block-list block-list">
                      <div>
                        <label>{{ 'telco-customer-info.identityProof' | translate }}:</label>
                        <p class="note">{{ 'telco-customer-info.proofNote' | translate }}</p>
                      </div>
                      <div hidden="true">
                        <input #identityProofEdit type="file" id="identityProofEdit" accept="image/*" hidden="true"
                          (change)="onImageChange($event,'identityProof','edit')">
                      </div>
                      <button class="add-proof-btn" *ngIf="editForm.get('identityProof').value == ''"
                        (click)="addImageButton('identityProofEdit')">{{ 'generic.add' | translate }}</button>
                      <div class="proof-image" *ngIf="editForm.get('identityProof').value != ''">
                        <img [src]="editForm.get('identityProof').value" alt="">
                        <button (click)="removeIcon('identityProof','edit')">{{ 'generic.remove' | translate }}</button>
                      </div>
                    </div>
                    <div class="proof-block-list block-list">
                      <div>
                        <label>{{ 'telco-customer-info.photoProof' | translate }}:</label>
                        <p class="note">{{ 'telco-customer-info.proofNote' | translate }}</p>
                      </div>
                      <div hidden="true">
                        <input #photoProofEdit type="file" id="photoProofEdit" accept="image/*" hidden="true"
                          (change)="onImageChange($event,'photoProof','edit')">
                      </div>
                      <button class="add-proof-btn" *ngIf="editForm.get('photoProof').value == ''"
                        (click)="addImageButton('photoProofEdit')">{{ 'generic.add' | translate }}</button>
                      <div class="proof-image" *ngIf="editForm.get('photoProof').value != ''">
                        <img [src]="editForm.get('photoProof').value" alt="">
                        <button (click)="removeIcon('photoProof','edit')">{{ 'generic.remove' | translate }}</button>
                      </div>
                    </div>
                    <div class="proof-block-list block-list">
                      <div>
                        <label>{{ 'telco-customer-info.addressProof' | translate }}:</label>
                        <p class="note">{{ 'telco-customer-info.proofNote' | translate }}</p>
                      </div>
                      <div hidden="true">
                        <input #addressProofEdit type="file" id="addressProofEdit" accept="image/*" hidden="true"
                          (change)="onImageChange($event,'addressProof','edit')">
                      </div>
                      <button class="add-proof-btn" *ngIf="editForm.get('addressProof').value == ''"
                        (click)="addImageButton('addressProofEdit')">{{ 'generic.add' | translate }}</button>
                      <div class="proof-image" *ngIf="editForm.get('addressProof').value != ''">
                        <img [src]="editForm.get('addressProof').value" alt="">
                        <!-- <div class="loader-image">
                                      <i class="bi bi-arrow-clockwise"></i>
                                  </div> -->
                        <button (click)="removeIcon('addressProof','edit')">{{ 'generic.remove' | translate }}</button>
                      </div>
                    </div>
                  </div>
                </div>

                <!--  <div class="col-md-6 col-lg-6">
                      <div class="form-group">
                        
                      </div>
                  </div> -->
              </div>
            </div>

            <hr />

            <!-- Service Info -->




            <h3 class="title-header">{{ 'telco-customer-info.serviceInfo' | translate }} <i class="bi bi-plus-circle"
                (click)="addServiceInfoEdit()"></i></h3>
            <div formArrayName="serviceInfo" class="section">

              <div *ngFor="let service of serviceInfoEdit?.controls; let i = index" [formGroupName]="i"
                class="nested-group">

                <div class="row">
                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Service:</label>
                      <select name="" id="" class="form-control" formControlName="serviceName">
                        <option [value]="service.name" *ngFor="let service of serviceData">{{service.name}}</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Service Id:</label>
                      <input formControlName="serviceId" class="form-control" placeholder="Service Id" />
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Service Status:</label>
                      <select name="" formControlName="serviceStatus" class="form-control">
                        <option value="">-- select status --</option>
                        <option value="Active">{{'generic.active' | translate}}</option>
                        <option value="InActive">{{'generic.inactive' | translate}}</option>

                      </select>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Service Info:</label>
                      <input formControlName="serviceInfo" class="form-control" placeholder="Service Info" />
                    </div>
                  </div>


                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Ext Customer Id:</label>
                      <input formControlName="extCustomerId" class="form-control" placeholder="Ext Customer Id" />
                    </div>
                  </div>

                </div>


                <!-- SIP Info -->
                <div formArrayName="sipInfo" class="sub-section">
                  <h5>{{ 'telco-customer-info.sipInfo' | translate }} <i class="bi bi-plus-circle"
                      (click)="addSipInfoEdit(i)"></i></h5>
                  <div *ngFor="let sip of getSipInfoControlsEdit(i); let j = index" [formGroupName]="j">


                    <div class="row">
                      <div class="col-md-5 col-lg-5">
                        <div class="form-group">
                          <input formControlName="sipName" class="form-control" placeholder="SIP Name" />
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                          <input formControlName="sipValue" class="form-control" placeholder="SIP Value" />
                        </div>
                      </div>
                      <div class="col-md-1 col-lg-1 remove">
                        <i class="bi bi-trash" (click)="removeSipInfoEdit(i,j)"></i>
                      </div>
                    </div>


                    <!-- <div formArrayName="keyValueDto" class="keyvalue-section">
                      <div
                        *ngFor="let kv of (sip.get('keyValueDto')?.['controls'] || []); let k = index"
                        [formGroupName]="k"
                      >
                        <input formControlName="key" placeholder="Key" />
                        <input formControlName="value" placeholder="Value" />
                      </div>
                    </div> -->
                  </div>
                </div>
                <div>

                  <div class="sub-section">
                    <h5>{{'telco-customer-info.asset' | translate}}</h5>

                    <div class="row">

                      <!-- Multi-select -->
                      <div class="col-md-12 col-lg-12">
                        <ng-multiselect-dropdown [placeholder]="'Select Asset'" [ngModel]="getSelectedAssetsEdit(i)"
                          [settings]="objectDropdownSettings" [data]="objectInfoList"
                          [ngModelOptions]="{standalone: true}" (onSelect)="onObjectSelectEdit($event,i)"
                          (onDeSelect)="onObjectDeSelectEdit($event, i)">

                          >
                        </ng-multiselect-dropdown>
                      </div>

                    </div>

                  </div>
                </div>

                <!-- <div class="sub-section">
                  <h5>{{'telco-customer-info.asset' | translate}} </h5>

                    <div class="row">
                      <div class="col-md-12 col-lg-12">
                        <div class="form-group">
                            <select name="" (change)="onAssetSelectEdit(i)" formControlName="assetId" class="form-control">
                              <option value="" selected disabled> -- select asset--</option>
                              <option value="{{list.objectInfoId}}" *ngFor="let list of objectInfoList">{{list.givenName}}</option>
                            </select>
                        </div>
                      </div>
                      <div class="col-md-12 col-lg-12">
                        <ng-multiselect-dropdown
                            [placeholder]="'select asset'"
                            [settings]="objectDropdownSettings"
                            [data]="objectInfoList"
                            [(ngModel)]="objectSelectedList"
                            class="form-control"
                            style="padding: 0;border: none"
                            [ngModelOptions]="{standalone: true}"
                            (onSelect)="onObjectItemSelect($event)"
                            (onSelectAll)="onObjectSelectAll($event)"
                            >
                        </ng-multiselect-dropdown>
                      </div>
                    </div>
                </div> -->




                <!-- DIP Info -->
                <div formArrayName="dipInfo" class="sub-section">
                  <h5>{{ 'telco-customer-info.dipInfo' | translate }} <i class="bi bi-plus-circle"
                      (click)="addDipInfoEdit(i)"></i></h5>
                  <div *ngFor="let dip of getDipInfoControlsEdit(i); let j = index" [formGroupName]="j">
                    <div class="row">
                      <div class="col-md-5 col-lg-5">
                        <div class="form-group">
                          <input formControlName="dipName" class="form-control" placeholder="DIP Name" />
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                          <input formControlName="dipValue" class="form-control" placeholder="DIP Value" />
                        </div>
                      </div>
                      <div class="col-md-1 col-lg-1 remove">
                        <i class="bi bi-trash" (click)="removeDipInfoEdit(i,j)"></i>
                      </div>
                    </div>

                    <!-- <div formArrayName="keyValueDto" class="keyvalue-section">
                      <div
                        *ngFor="let kv of (dip.get('keyValueDto')?.['controls'] || []); let k = index"
                        [formGroupName]="k"
                      >
                        <input formControlName="key" placeholder="Key" />
                        <input formControlName="value" placeholder="Value" />
                      </div>
                    </div> -->
                  </div>
                </div>

                <!-- Dealer Info -->
                <div formArrayName="dealerInfo" class="sub-section">
                  <h5>{{ 'telco-customer-info.dealerInfo' | translate }} <i class="bi bi-plus-circle"
                      (click)="addDealerInfoEdit(i)"></i></h5>
                  <div *ngFor="let dealer of getDealerInfoControlsEdit(i); let j = index" [formGroupName]="j">


                    <div class="row">
                      <div class="col-md-5 col-lg-5">
                        <div class="form-group">
                          <select name="" formControlName="dealerName" class="form-control">
                            <option value="" selected disabled> -- {{ 'generic.select' | translate }} {{
                              'telco-customer-info.dealerInfo' | translate }} --</option>
                            <option value="{{list.idealerId}}" *ngFor="let list of dealerList">{{list.name}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                          <select name="" id="" formControlName="dealerLocation" class="form-control">
                            <option value="" selected disabled> -- select location --</option>
                            <option value="{{list.zone}}" *ngFor="let list of locationList">{{list.zone}} -
                              {{list.city}} - {{list.postalCode}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-1 col-lg-1 remove">
                        <i class="bi bi-trash" (click)="removeDealerInfoEdit(i,j)"></i>
                      </div>
                    </div>

                    <!-- <div formArrayName="keyValueDto" class="keyvalue-section">
                      <div
                        *ngFor="let kv of (dealer.get('keyValueDto')?.['controls'] || []); let k = index"
                        [formGroupName]="k"
                      >
                        <input formControlName="key" placeholder="Key" />
                        <input formControlName="value" placeholder="Value" />
                      </div>
                    </div> -->
                  </div>
                </div>

                <div class="service-remove">
                  <button type="button" (click)="serviceInfoEdit.removeAt(i)"> <i class="bi bi-trash"></i> {{
                    'telco-customer-info.removeService' | translate }}</button>
                </div>

              </div>

              <!-- <button type="button" (click)="addServiceInfo()">+ Add New Service</button> -->
            </div>

            <hr />

            <!-- Key Values -->
            <!-- <div formGroupName="keyValues" class="section">
              <h3>{{'telco-customer-info.keyValues' | translate}}</h3>

              <input formControlName="key" placeholder="Key" />
              <input formControlName="value" placeholder="Value" />
            </div> -->

            <!-- Actions -->
            <!-- <div class="actions">
              <button type="submit" [disabled]="addForm.invalid">💾 Submit</button>
              <button type="button" (click)="clearForm()">🧹 Clear</button>
            </div> -->
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeUpdateModal" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel'
            | translate }}</button>
          <button type="button" (click)="updateTelcoCustomer()" class="btn btn-primary">{{ 'generic.update' | translate
            }}</button>
        </div>
      </div>
    </div>
  </div>
</div>



<button style="display: none;" id="view-object" data-toggle="modal" data-target="#viewObjectModal"></button>

<div class="modal fade" id="viewObjectModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'object-info.headings.detail' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div class="form-group" *ngFor="let viewData of singleObjectInfoData">
          <div class="row">
            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.objectInfoId' | translate }} :</label>
              <p>{{viewData.objectInfoId || '--'}}</p>
            </div>
            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.name' | translate }} :</label>
              <p>{{viewData.name || '--'}}</p>
            </div>
            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.givenName' | translate }} :</label>
              <p>{{viewData.givenName || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6" *ngIf="viewData.serialNumberCheckBox">
              <label>{{ 'object-info.serialNumber' | translate }} :</label>
              <p>{{viewData.serialNumber || '--'}}</p>
            </div>
            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.group' | translate }} :</label>
              <p>{{viewData.group || '--'}}</p>
            </div>
            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.type' | translate }} :</label>
              <p>{{viewData.type || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6" *ngIf="viewData.modelCheckBox">
              <label>{{ 'object-info.model' | translate }} :</label>
              <p>{{viewData.model || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6" *ngIf="viewData.makeCheckBox">
              <label>{{ 'object-info.make' | translate }} :</label>
              <p>{{viewData.make || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.objectCondition' | translate }} :</label>
              <p>{{viewData.objectCondition || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6">
              <label>Asset Status :</label>
              <p>{{viewData.assetStatus || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6" *ngIf="viewData.originalCostCheckBox">
              <label>{{ 'object-info.originalCost' | translate }} :</label>
              <p>{{viewData.originalCost || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6" *ngIf="viewData.currentCostCheckBox">
              <label>{{ 'object-info.currentCost' | translate }} :</label>
              <p>{{viewData.currentCost || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6" *ngIf="viewData.branchCheckBox">
              <label>{{ 'object-info.branch' | translate }} :</label>
              <p>{{viewData.branch || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6" *ngIf="viewData.departmentCheckBox">
              <label>{{ 'object-info.department' | translate }} :</label>
              <p>{{viewData.department || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.location' | translate }} :</label>
              <p>{{viewData.location || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.country' | translate }} :</label>
              <p>{{viewData.country || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.provinceOrState' | translate }} :</label>
              <p>{{viewData.provinceOrState || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.zone' | translate }} :</label>
              <p>{{viewData.zone || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.postalCode' | translate }} :</label>
              <p>{{viewData.postalCode || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.city' | translate }} :</label>
              <p>{{viewData.city || '--'}}</p>
            </div>


            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.createdDate' | translate }} :</label>
              <p>{{viewData.createdDate | date}}</p>
            </div>

            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.acquisitionDate' | translate }} :</label>
              <p>{{viewData.acquisitionDate || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6" *ngIf="viewData.depreciationCheckbox">
              <label>{{ 'object-info.salvageValue' | translate }} :</label>
              <p>{{viewData.salvageValue || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6" *ngIf="viewData.depreciationCheckbox">
              <label>{{ 'object-info.depreciationMethod' | translate }} :</label>
              <p>{{viewData.depreciationMethod || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6" *ngIf="viewData.departmentCheckBox">
              <label>{{ 'object-info.assetLifeNumber' | translate }} :</label>
              <p>{{viewData.assetLifeNumber || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.asset_Category' | translate }} :</label>
              <p>{{viewData.asset_Category || '--'}}</p>
            </div>
            <div class="col-md-12 col-lg-12 qr-code">
              <label>{{ 'object-info.qr_code' | translate }} :</label>
              <qrcode [qrdata]="jsonString" [width]="150" [errorCorrectionLevel]="'M'"></qrcode>
            </div>


            <div class="col-md-12 col-lg-12">
              <div class="image-container" style="margin-top: 20px;">
                <div class="image-header image-header1">
                  <h5>{{ 'object-info.images' | translate }}</h5>
                </div>


                <div class="image-content-block">
                  <div class="image-single" *ngFor="let image of viewData.imagesWithDetails;let i = index">
                    <p>{{image.name}}</p>
                    <img src="{{image.image}}" alt="">
                  </div>
                </div>



              </div>
            </div>

            <div class="col-md-12 col-lg-12" *ngIf="viewData.nameValue && viewData.nameValue.length != 0">
              <h5 class="data-list-title">{{ 'object-info.nameValue' | translate }}</h5>
            </div>

            <div class="col-md-12 col-lg-12 data-list" *ngIf="viewData.nameValue && viewData.nameValue.length != 0">

              <div class="list-block">
                <ul class="ui-tree">
                  <ng-container *ngFor="let item of viewData.nameValue">
                    <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: item }"></ng-container>
                  </ng-container>
                </ul>

                <ng-template #renderNode let-node>
                  <li>
                    <strong>{{ node.key }}:</strong> {{ node.value }}
                    <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                      <ng-container *ngFor="let child of node.keyValue">
                        <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: child }"></ng-container>
                      </ng-container>
                    </ul>
                  </li>
                </ng-template>
              </div>
            </div>

            <div class="col-md-12 col-lg-12"
              *ngIf="viewData.performanceMatrix && viewData.performanceMatrix.length != 0">
              <h5 class="data-list-title">{{ 'object-info.performanceMatrix' | translate }} </h5>
            </div>


            <div class="col-md-12 col-lg-12" *ngIf="viewData.warranty">
              <h5 class="data-list-title">{{ 'object-info.warranty' | translate }}</h5>
            </div>

            <div class="col-md-12 col-lg-12 data-list" *ngIf="viewData.warranty">
              <div class="list-block">
                <ul class="ui-tree">
                  <li *ngFor="let warrantyInfo of viewData.warrantyInfo">
                    <strong>{{ warrantyInfo.key }}:</strong> {{ warrantyInfo.value }}
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-md-12 col-lg-12" *ngIf="viewData.purchase">
              <h5 class="data-list-title">{{ 'object-info.purchase' | translate }}</h5>
            </div>

            <div class="col-md-12 col-lg-12 data-list" *ngIf="viewData.purchase">
              <div class="list-block">
                <ul class="ui-tree">
                  <li *ngFor="let purchaseInfo of viewData.purchaseInfo">
                    <strong>{{ purchaseInfo.key }}:</strong> {{ purchaseInfo.value }}
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-md-12 col-lg-12 data-list"
              *ngIf="viewData.performanceMatrix && viewData.performanceMatrix.length != 0">

              <div class="list-block">
                <ul class="ui-tree">
                  <ng-container *ngFor="let item of viewData.performanceMatrix">
                    <ng-container *ngTemplateOutlet="renderNode1; context: { $implicit: item }"></ng-container>
                  </ng-container>
                </ul>

                <ng-template #renderNode1 let-node>
                  <li>
                    <strong>{{ node.key }}:</strong> {{ node.value }}
                    <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                      <ng-container *ngFor="let child of node.keyValue">
                        <ng-container *ngTemplateOutlet="renderNode1; context: { $implicit: child }"></ng-container>
                      </ng-container>
                    </ul>
                  </li>
                </ng-template>
              </div>
            </div>



            <div class="col-md-12 col-lg-12" style="padding: 0;"
              *ngIf="viewData.repairInfos && viewData.repairInfos.length != 0">
              <h5 class="repair-list-title">{{ 'object-info.repairList' | translate }}</h5>




              <div class="repair-list-block">
                <div class="list" *ngFor="let list of viewData.repairInfos">
                  <div>
                    <p><label>{{ 'object-info.repairDone' | translate }} :</label> {{list.description || '--'}}</p>
                  </div>

                  <div class="dates">
                    <p><label>{{ 'object-info.repairGivenTo' | translate }} :</label> {{list.repairGivenTo || '--'}}</p>
                    <p><label>{{ 'object-info.userName' | translate }} :</label> {{list.userName || '--'}}</p>
                    <p><label>{{ 'object-info.phNo' | translate }} :</label> {{list.phNo || '--'}}</p>
                    <p><label>{{ 'object-info.emailId' | translate }} :</label> {{list.emailId || '--'}}</p>
                    <p><label>{{ 'object-info.repairGivenDate' | translate }} :</label> {{list.repairGivenDate | date}}
                    </p>
                    <p><label>{{ 'object-info.repairExpectedEndDate' | translate }} :</label>
                      {{list.repairExpectedEndDate | date}}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12 col-lg-12" style="padding: 0;"
              *ngIf="viewData.assetHealth && viewData.assetHealth.length != 0">
              <h5 class="repair-list-title">{{ 'object-info.connections' | translate }}</h5>

              <div class="row">
                <div class="col-md-6 col-lg-6">
                  <label>{{ 'object-info.assetMonitoringFrequency' | translate }} :</label>
                  <p>{{viewData.assetMonitoringFrequency || '--'}}</p>
                </div>

                <div class="col-md-6 col-lg-6">
                  <label>{{ 'object-info.assetMonitoringTimeSpan' | translate }} :</label>
                  <p>{{viewData.assetMonitoringTimeSpan || '--'}}</p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 col-lg-6" *ngFor="let connectionDetails of viewData.connectionDetails">
                  <label>{{connectionDetails.key || '--'}} :</label>
                  <p>{{connectionDetails.value || '--'}}</p>
                </div>
              </div>
            </div>



            <div class="col-md-12 col-lg-12" style="padding: 0;"
              *ngIf="viewData.assetHealth && viewData.assetHealth.length != 0">
              <h5 class="repair-list-title">{{ 'object-info.assetHealth' | translate }}</h5>

              <div class="row">
                <div class="col-md-6 col-lg-6" *ngFor="let assetHealthList of viewData.assetHealth">
                  <label>{{assetHealthList.key || '--'}} :</label>
                  <p>{{assetHealthList.value || '--'}}</p>
                </div>
              </div>
            </div>



            <div class="nameValue" *ngIf="viewData.performance">
              <div>
                <h5 class="multi-title">{{ 'object-info.assetPerformance' | translate }}</h5>

                <div class="row keys-content">

                  <div class="col-md-12 col-lg-12 keysBlock">
                    <div class="form-group">
                      <label for="">{{ 'object-info.timeSpan' | translate }}</label>
                      <p>{{viewData.assetPerformance?.timeSpan}}</p>

                    </div>

                    <div class="form-group">
                      <label for="">{{ 'object-info.uom' | translate }}</label>
                      <p>{{viewData.assetPerformance?.uom || '--'}}</p>
                    </div>

                    <div class="form-group">
                      <label for="">{{ 'object-info.expectedOutput' | translate }}</label>
                      <p>{{viewData.assetPerformance?.expectedOutput || '--'}}</p>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12 col-lg-12" style="padding: 0;" *ngIf="viewData.tags && viewData.tags.length != 0">
              <h5 class="repair-list-title">{{ 'object-info.tags' | translate }}</h5>
              <div class="tag-list">
                <p class="tag" *ngFor="let list of viewData.tags">{{list}}</p>
              </div>
            </div>

          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton1" class="btn btn-secondary" data-dismiss="modal">{{
            'generic.cancel' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>